import { getFromLocalStorage } from '../hooks/useLocalStorage'

const checkClientConfig = (configName,isValueRequired=null) => {
    const companyConfiguration = getFromLocalStorage("user")?.clinetConfiguration
    return isValueRequired ? companyConfiguration?.find(item => item.name === configName)?.is_active && companyConfiguration?.find(item => item.name === configName)?.value : companyConfiguration?.find(item => item.name === configName)?.is_active
}

 export const checkClientConfigKey = (configName) => {
    const companyConfiguration = getFromLocalStorage("user")?.clinetConfiguration
    // console.log(companyConfiguration?.find(item => item.name === configName)?.is_active ,"check",configName)
    // console.log(companyConfiguration?.find(item => item.name === configName)?.is_active ,"check",configName,companyConfiguration?.find(item => item.name === configName)?.is_active && companyConfiguration?.find(item => item.name === configName)?.key,"condition")
    return companyConfiguration?.find(item => item.name === configName)?.is_active && companyConfiguration?.find(item => item.name === configName)?.key
}

 export const checkAPIClientConfigKey = (companyConfiguration, configName) => {    
    return companyConfiguration?.find(item => item.name === configName)?.is_active && companyConfiguration?.find(item => item.name === configName)?.key
}

export const checkAPIClientConfigStatus = (companyConfiguration, configName) => {    
    return companyConfiguration?.find(item => item.name === configName)?.is_active 
}


export default checkClientConfig
